export type CustomerOrdersViewRange = "all" | "7d" | "30d" | "3m";

export function normalizeCustomerOrdersViewRange(value: unknown): CustomerOrdersViewRange {
  return value === "7d" || value === "30d" || value === "3m" ? value : "all";
}

export function customerOrdersViewDateFrom(range: CustomerOrdersViewRange, now = new Date()): string {
  if (range === "all") return "";
  const days = range === "7d" ? 7 : range === "30d" ? 30 : 90;
  const from = new Date(now);
  from.setUTCDate(from.getUTCDate() - days);
  return from.toISOString().slice(0, 10);
}
